module.exports = __webpack_public_path__ + "static/20-the-real-impact-of-automation-on-the-gig-economy-595e84a6a3d6b062b44e91c7ca272018.jpg";